import { createSelector } from 'reselect';
import WorkspaceTemplatesConstants from 'Shared/constants/WorkspaceTemplates.constants';

const getWorkspaceTemplatesItems = state => state.workspaceTemplatesItems;

function createParameterSelector(selector) {
  return (_, params) => selector(params);
}

const getTypeParam = createParameterSelector(params => params.type);
const getSlugParam = createParameterSelector(params => params.slug);

export const getAllWorkspaceTemplates = createSelector([getWorkspaceTemplatesItems], workspaceTemplates => {
  return workspaceTemplates.get(WorkspaceTemplatesConstants.State.WORKSPACES_TEMPLATES_BY_SLUG);
});

export const getWorkspaceTemplateBySlug = createSelector(
  [getAllWorkspaceTemplates, getSlugParam],
  (workspaceTemplates, slug) => workspaceTemplates.get(slug)
);

export const getWorkspaceTemplatesByType = createSelector(
  [getAllWorkspaceTemplates, getTypeParam],
  (workspaceTemplates, type) =>
    workspaceTemplates.filter(workspaceTemplate => (type ? workspaceTemplate.get('templateType') === type : true))
);
